import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { UserPlus, Heart, Inbox, ShieldAlert } from "lucide-react";

const ICONS = {
    signup: { icon: UserPlus, color: "#10B981" },
    match: { icon: Heart, color: "#EC4899" },
    waitlist: { icon: Inbox, color: "#84CC16" },
    admin: { icon: ShieldAlert, color: "#E85D5D" },
};

export default function AdminActivity() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await adminApi.get("/admin/activity", { params: { limit: 100 } });
                setEvents(data.events || []);
            } catch (e) {}
            setLoading(false);
        })();
    }, []);

    return (
        <div data-testid="admin-activity-page">
            <h1 className="font-display text-3xl font-black">Activity</h1>
            <p className="text-sm text-white/50">Real-time signal from across Flatch.</p>

            <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 divide-y divide-white/5" data-testid="admin-activity-feed">
                {loading ? (
                    <div className="p-6 text-white/50 text-sm">Loading…</div>
                ) : events.length === 0 ? (
                    <div className="p-6 text-white/50 text-sm">No activity yet</div>
                ) : events.map((e, i) => {
                    const conf = ICONS[e.type] || ICONS.signup;
                    const Icon = conf.icon;
                    return (
                        <div key={i} className="p-3 flex items-center gap-3">
                            <div className="h-8 w-8 rounded-lg grid place-items-center flex-shrink-0" style={{ background: `${conf.color}30`, color: conf.color }}>
                                <Icon className="h-4 w-4" strokeWidth={2.5} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-sm truncate">{e.text}</div>
                                <div className="text-xs text-white/40">{(e.at || "").slice(0, 16).replace("T", " ")}</div>
                            </div>
                            <div className="text-[9px] font-black uppercase tracking-widest text-white/40">
                                {e.type}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
